import React from "react";
import TableCell from "./TableCell";
import {IconButton, makeStyles} from "@material-ui/core";
import {DragIndicator} from "@material-ui/icons";
import {Draggable} from "react-beautiful-dnd";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
    trMenu: {
        position: 'absolute',
        width: 40,
        left: -42,
        top: 0,
        borderTop: '1px',
        borderBottom: '1px',
        borderLeft: '1px',
        borderStyle: "solid",
        borderColor: "#dedede",
        height: '95%',
        borderRadius: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    rowMenu: {
        visibility: 'visible',
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center'
    },
    tr: {
        position: 'relative',
        '& $rowMenu': {
            visibility: 'hidden',
        },
        '&:hover': {
            '& $rowMenu': {
                visibility: 'visible',
            }
        }
    },
    trDraggable: {
        border: "none",
        width: '100%',
        background: 'rgba(210,210,210,0.38)',
        '& > td': {
            border: "none"
        }
    }
}))
const TableRowDnd = (props) => {
    const classes = useStyles();
    const {
        component, rowIndex, actionsContext, containerArrayPath,
        index, openContextMenu, allowActions, onClickEvent, handleMouseMove
    } = props

    return (
        <Draggable draggableId={containerArrayPath} index={index} key={index}>
            {(provided, snapshot) => (
                <tr className={clsx(classes.tr, {[classes.trDraggable]: snapshot.isDragging})}
                    {...provided.draggableProps}
                    ref={provided.innerRef}
                    onMouseMove={(e) => handleMouseMove(e, index)}
                    style={{
                        ...provided.draggableProps.style,
                    }}
                    onContextMenu={(e) => {
                        e.preventDefault()
                        openContextMenu(e, index)
                    }}
                    onClick={(event) => {
                        event.stopPropagation();
                        onClickEvent(actionsContext)
                    }}
                >
                    {allowActions && (
                        <>
                            {rowIndex === 0 ? (
                                    <th style={{
                                        width: 20,
                                        border: "none"
                                    }} colSpan={1}></th>
                                ) :
                                (
                                    <th
                                        colSpan={1}
                                        style={{
                                            width: 20,
                                            border: "none"
                                        }}
                                    >
                                        <div className={classes.rowMenu}>
                                            <IconButton size={"small"}
                                                        style={{padding: 0}}
                                                        {...provided.dragHandleProps}
                                                        tabIndex={-1}
                                            >
                                                <DragIndicator
                                                    fontSize={"small"}/>
                                            </IconButton>
                                        </div>

                                    </th>
                                )}
                        </>
                    )}
                    {component.children.map((component, index) => {
                        return (
                            <TableCell
                                key={index}
                                rowIndex={rowIndex}
                                component={component}
                                actionsContext={actionsContext}
                                containerArrayPath={containerArrayPath}
                            />
                        )
                    })}
                </tr>
            )}
        </Draggable>
    )
}

export default TableRowDnd
